import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';

import { GlobalHeadwindsSection } from '@/components/ui/features/publishers/GlobalHeadwindsSection/GlobalHeadwindsSection';
import { PublishersHeader } from '@/components/ui/features/publishers/PublishersHeader/PublishersHeader';
import { ReadyToTransform } from '@/components/ui/features/publishers/ReadyToTransform/ReadyToTransform';
import { ReasonsSection } from '@/components/ui/features/publishers/ReasonsSection/ReasonsSection';
import { TripleRSection } from '@/components/ui/features/publishers/TripleRSection/TripleRSection';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { queryTestimonials } from '@/queries/testimonals';
import { generateStore } from '@/utils/generateStore';
import { Hydrate } from '@/utils/swr/Hydrate';

const ForPublishers: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ fallback }) => {
  return (
    <Hydrate fallback={fallback}>
      <Layout accessFrom={AccessFrom.Core} navigationVariant="ghost">
        <PublishersHeader />
        <GlobalHeadwindsSection />
        <TripleRSection />
        <ReasonsSection />
        <ReadyToTransform />
      </Layout>
    </Hydrate>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });

  await store.fetchResources(queryTestimonials());

  return {
    props: {
      fallback: store.fallback,
    },
  };
};
export default ForPublishers;
